import { isUndefined } from './../utils';
/**
 * Returns a random identifier which can be used as an ID of objects, eventually augmented with a prefix.
 *
 * @returns {string}
 */
export function randomId(length) {
    if (isUndefined(length)) {
        length = 10;
    }
    // old version return Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1);
    let result = '';
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = length; i > 0; --i) {
        result += chars.charAt(Math.round(Math.random() * (chars.length - 1)));
    }
    return result;
}
